import React, { Component } from "react";
import EditPlayersDialog from "../../components/teams/EditPlayersDialog";
import PersonIcon from "@material-ui/icons/PersonAdd";
import IconButton from "@material-ui/core/IconButton";

class EditPlayersContainer extends Component {
  state = {
    open: false,
    name: "",
    age: "",
    number: "",
    infoFields: {},
    selectedPlayer: "",
    addPlayer: false,
    submitDisabled: true,
    playerList: "",
  };

  toggleAddPlayer = () => {
    this.setState({ addPlayer: true });
  };

  selectPlayer = (e, player) => {
    const newState = {
      selectedPlayer: player.id,
      name: player.name,
      age: player.age,
      number: player.number || "",
      infoFields: player.infoFieldsForTable || {},
    };
    this.setState(newState);
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  back = () => {
    this.setState({
      addPlayer: false,
      selectedPlayer: "",
      name: "",
      age: "",
      number: "",
      infoFields: {},
      playerList: "",
      value: 0,
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name" || event.target.name === "playerList") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.state.selectedPlayer) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleChangeInfoField = (event) => {
    let newState = this.state.infoFields;
    newState[event.target.name] = event.target.value;

    this.setState({ infoFields: newState, submitDisabled: false });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 9) {
      // tab was pressed
      // get caret position/selection
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;

      var target = e.target;
      var value = target.value;
      // set textarea value to: text before caret + tab + text after caret
      target.value = value.substring(0, start) + "\t" + value.substring(end);
      // put caret at right position again (add one for the tab)
      this.selectionStart = this.selectionEnd = start + 1;

      // prevent the focus lose
      e.preventDefault();
      this.handleChange(e);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    const player = {
      name: this.state.name,
      age: this.state.age,
      number: this.state.number,
      infoFields: {},
      team: this.props.team.id,
      division: this.props.division.id,
    };
    const db = window.firebase.firestore();

    // Get a new write batch
    const batch = db.batch();

    Object.keys(this.props.tournament.infoFieldsPlayers || {})
      .filter((key) => ["name", "age", "number"].indexOf(key) === -1)
      .forEach((key) => {
        if (this.props.tournament.infoFieldsPlayers[key].showOnLive) {
          player.infoFields[key] = this.state.infoFields[key] || "";
        }
      });

    var playerRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("players");
    if (this.state.selectedPlayer) {
      playerRef = playerRef.doc(this.state.selectedPlayer);
      batch.update(playerRef, player);
    } else {
      // set created at timestamp
      player["createdAt"] =
        window.firebase.firestore.FieldValue.serverTimestamp();

      playerRef = playerRef.doc();
      batch.set(playerRef, player);
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("player_added");
      }
    }

    var playerContactRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("playersContactInfo")
      .doc(playerRef.id);

    let playerContactInfo = {};
    Object.keys(this.props.tournament.infoFieldsPlayers || {})
      .filter((key) => ["name", "age", "number"].indexOf(key) === -1)
      .forEach((key) => {
        playerContactInfo[key] = this.state.infoFields[key] || "";
      });
    batch.set(playerContactRef, playerContactInfo);

    // Commit the batch
    batch.commit();
    this.back();
  };

  handleSubmitMultiple = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    const db = window.firebase.firestore();
    let batch = db.batch();
    var playerRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("players");
    let splitted = this.state.playerList.split("\n");

    for (let i in splitted) {
      let split = splitted[i];
      if (split !== "" && split !== " ") {
        let splittedSplit = split.split("\t");
        let playerData = {
          name: splittedSplit[0],
          age: splittedSplit[1] || "",
          number: splittedSplit[2] || "",
          team: this.props.team.id,
          division: this.props.division.id,
          createdAt: window.firebase.firestore.FieldValue.serverTimestamp(),
        };
        let playerDoc = playerRef.doc();
        batch.set(playerDoc, playerData);
      }
    }
    batch.commit();
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("multiple_players_added");
    }
    this.back();
  };

  handleDelete = (e, playerId) => {
    this.back();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef.collection("players").doc(playerId).delete();
  };

  render() {
    let players = this.props.players;
    players = players.map((player) => {
      let playerCopy = player;
      if (this.props.playersContactInfoLoaded) {
        playerCopy.infoFieldsForTable = {};
        Object.keys(this.props.tournament.infoFieldsPlayers || {})
          .filter((key) => ["name", "age", "number"].indexOf(key) === -1)
          .forEach((key) => {
            if (
              (this.props.playersContactInfo[player.id] || {})[key] !==
              undefined
            ) {
              playerCopy.infoFieldsForTable[key] = (this.props
                .playersContactInfo[player.id] || {})[key];
            }
          });
      }
      return playerCopy;
    });

    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          disabled={this.props.disabled}
          style={{ padding: 5 }}
        >
          <PersonIcon />
        </IconButton>
        {this.props.players.length > 0 && "(" + this.props.players.length + ")"}
        <EditPlayersDialog
          name={this.state.name}
          age={this.state.age}
          number={this.state.number}
          infoFields={this.state.infoFields}
          selectedPlayer={this.state.selectedPlayer}
          submitDisabled={this.state.submitDisabled}
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleChangeInfoField={this.handleChangeInfoField}
          handleSubmit={this.handleSubmit}
          division={this.props.division}
          players={players}
          handleSubmitMultiple={this.handleSubmitMultiple}
          handleKeyDown={this.handleKeyDown}
          toggleAddPlayer={this.toggleAddPlayer}
          selectPlayer={this.selectPlayer}
          back={this.back}
          addPlayer={this.state.addPlayer}
          handleDelete={this.handleDelete}
          team={this.props.team}
          tournament={this.props.tournament}
        />
      </div>
    );
  }
}

export default EditPlayersContainer;
